import { Outlet, useRouter } from "@tanstack/react-router";
import { Sidebar } from "./Sidebar/Sidebar";
import { TopBar } from "./TopBar/TopBar";
import { useAuth } from "../context/AuthContext";
import { useEffect } from "react";

export function Layout() {
  const { user, logout } = useAuth();
  const router = useRouter();
  const currentPath = router.state.location.pathname;

  console.log("user", user);

  // Ensure we get the correct basepath based on user role
  const basepath = user?.role?.toLowerCase() || 'clinic';

  useEffect(() => {
    if (!user && !currentPath.includes("/login")) {
      // Determine which login page to redirect to based on the current URL path
      const loginPath = currentPath.startsWith("/admin")
        ? "/admin/login"
        : currentPath.startsWith("/medicalcamp")
        ? "/medicalcamp/login"
        : currentPath.startsWith("/lab")
        ? "/lab/login"
        : "/clinic/login";
      router.navigate({ to: loginPath });
      return;
    }

    if (user && currentPath.includes("/login")) {
      // Redirect to the appropriate dashboard based on user role
      router.navigate({ to: `/${basepath}/dashboard` });
    }
    
    // Handle cases where a user might try to access a path that doesn't match their role
    if (user && !currentPath.includes("/login")) {
      const userPathPrefix = `/${basepath}`;
      if (!currentPath.startsWith(userPathPrefix)) {
        router.navigate({ to: `${userPathPrefix}/dashboard` });
      }
    }
  }, [user, currentPath, router, basepath]);

  if (currentPath.includes("/login")) {
    return <Outlet />;
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600" />
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      <div className="fixed inset-y-0 left-0 w-64">
        <Sidebar user={user} onLogout={logout} />
      </div>
      <div className="flex-1 ml-64 flex flex-col min-w-0">
        <TopBar />
        <main className="flex-1 overflow-y-auto p-6">
          <div className="mx-auto h-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}